import { TiendaCursos } from "./cursos";
import { TiendaClienteIndividual } from "./individual";

/**
 * Objeto que devuelve los componentes de las 3 tipos de tiendas.
 */
export const Tiendas = {
    TiendaClienteIndividual,
    TiendaCursos,
}